var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Page',{attrs:{"fetch-data":_vm.items,"fields":[
      {
        key: 'id',
        label: 'Pedido',
      },
      {
        key: 'customer_name',
        label: 'Cliente',
      },
      {
        key: 'created_at',
        label: 'Data da Transação',
      },
      {
        key: 'status',
        label: 'Status',
      },
      {
        key: 'value',
        label: 'Valor',
      } ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }